module.exports = __webpack_public_path__ + "95a5ecd93a04de44d1f3e4174aab4c82.pdf";